var _style, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.8 176.1",
    style: {
      enableBackground: "new 0 0 138.8 176.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8724,
    y1: 17.118,
    x2: 139.6927,
    y2: 136.6352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026616,
    style: {
      stopColor: "#51E5FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1739,
    style: {
      stopColor: "#0295FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    style: {
      stopColor: "#1669D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4367,
    style: {
      stopColor: "#2F32A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#3E108C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    style: {
      stopColor: "#440381"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6563,
    style: {
      stopColor: "#4A0381"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7152,
    style: {
      stopColor: "#5B0382"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7823,
    style: {
      stopColor: "#770383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    style: {
      stopColor: "#9D0384"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9328,
    style: {
      stopColor: "#CE0286"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0288"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.5,148.9l-37,25.1c-3.7,2.5-8.6,2.5-12.3,0l-37-25.1C9.9,137.8,0,119.2,0,99.4l0-77.5 c0-3.9,2.6-7.3,6.4-8.3L44,4c16.7-4.3,34.1-4.3,50.8,0l37.5,9.6c3.8,1,6.4,4.4,6.4,8.3v77.5C138.8,119.2,128.9,137.8,112.5,148.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46,118.6h2.8l5.4,12.6h-2.9l-1.2-3h-5.5l-1.1,3h-2.8L46,118.6z M47.3,121.1l-1.8,4.8h3.7L47.3,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,118.6h5.7c4,0,5.9,2.1,5.9,6.5c0,2.3-0.6,3.9-1.9,5c-0.5,0.4-1,0.7-1.6,0.9c-0.6,0.2-1.3,0.2-2.3,0.2 h-5.8V118.6z M61.8,120.8h-3.1v8.2h3.1c1.2,0,2-0.3,2.4-0.9c0.4-0.6,0.7-1.7,0.7-3.2c0-1.5-0.2-2.6-0.7-3.2 C63.8,121.1,63,120.8,61.8,120.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,118.6H77l5.4,12.6h-2.9l-1.2-3h-5.5l-1.1,3h-2.8L74.2,118.6z M75.5,121.1l-1.8,4.8h3.7L75.5,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,120.8h-6.5c-1.4,0-2,0.5-2,1.6c0,0.9,0.6,1.4,1.7,1.4h3.5c1.4,0,2.5,0.3,3.1,0.8 c0.6,0.5,0.9,1.5,0.9,2.7c0,2.6-1.4,3.8-4.4,3.8h-7v-2.2h6.6c1.5,0,2.1-0.4,2.1-1.4c0-1.1-0.5-1.5-1.9-1.5h-3.1 c-2.9,0-4.2-1.1-4.2-3.6c0-1.3,0.4-2.3,1.1-2.9c0.7-0.6,1.8-0.9,3.4-0.9h6.9V120.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,34.5h17.6c2.7,0,4.8,2.2,4.8,4.8l0,61c0.1,2.2-1.7,4.1-4,4.1h-11c-2.3,0-4.1-1.9-4-4.2l0.2-3.8 c0.1-2.3-1.7-4.2-4-4.2h-7.5c-1.7,0-3.2,1-3.7,2.6l-2.6,7c-0.6,1.6-2.1,2.6-3.7,2.6H44.9c-2.9,0-4.8-3-3.6-5.6l28.3-61.9 C70.2,35.4,71.6,34.5,73.1,34.5z M79.1,48.8h-0.2l-9.2,24.3c-1,2.6,0.9,5.4,3.7,5.4H74c2.1,0,3.9-1.7,4-3.8L79.1,48.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9,71.2V37.3c0-1.6,1.3-2.8,2.8-2.8h15.3c2.1,0,3.4,2.1,2.6,4L46.3,72.4C45.1,75.2,40.9,74.3,40.9,71.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdas);
export default __webpack_public_path__ + "static/media/adas.0be5099469b5e1449be1d08ccb3027eb.svg";
export { ForwardRef as ReactComponent };